import React, { useState } from 'react';
import { makeStyles, Menu, MenuItem } from '@material-ui/core';
import { mapProps } from 'recompose';
import { compose } from 'react-apollo';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import DeleteIcon from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import { MoreVertOutlined } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  actionMenuList: {
    padding: 0
  },
  moreIcon: {
    padding: '0.35rem',
    fontSize: '2rem',
    '&:hover': {
      backgroundColor: theme.palette.icon.iconHoverColor,
      borderRadius: '50%'
    }
  },
  menuItem: {
    color: '#616161',
    minHeight: '1.5rem',
    padding: '0.25rem 1rem',
    fontWeight: '500',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: theme.palette.icon.iconHoverColor
    },
    '&:focus': {
      backgroundColor: theme.palette.icon.iconHoverColor
    },
    '& svg': {
      marginRight: theme.whitespace.base,
      height: '20px',
      width: '20px'
    }
  }
}));

export const CommentActionsBase = props => {
  const { onDelete, onEdit, showActions, translate } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event?.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onDeleteHandler = () => {
    onDelete();
  };

  const onEditHandler = () => {
    onEdit();
  };

  return (
    <>
      {showActions && (
        <Box component="span" className={classes.more}>
          <IconButton
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MoreVertOutlined className={classes.moreIcon} />
          </IconButton>
          <Menu
            id="actions-menu"
            anchorEl={anchorEl}
            open={open}
            onClick={handleClose}
            classes={{ list: classes.actionMenuList }}
            PaperProps={{ style: { transform: 'translateX(-2px) translateY(40px)' } }}
          >
            <MenuItem className={classes.menuItem} onClick={onEditHandler}>
              <Edit />
              {translate('common.edit')}
            </MenuItem>
            <MenuItem className={classes.menuItem} onClick={onDeleteHandler}>
              <DeleteIcon />
              {translate('common.delete')}
            </MenuItem>
          </Menu>
        </Box>
      )}
    </>
  );
};

export const CommentActionsHOC = compose(
  withRouter,
  withTranslation(),
  mapProps(props => ({
    translate: props.t,
    history: props.history,
    onEdit: props.onEdit,
    showActions: props.showActions,
    onDelete: props.onDelete
  }))
);

export const CommentActions = CommentActionsHOC(CommentActionsBase);
